import { assertEvent } from 'xstate';
import { ActionEventParams } from '../../../../../apply/lib/types';
import { FraudAlloyContext } from './fraudAlloyMachine';
import {
  FraudAlloyMachineEvents,
  SendStartIDUploadJourneyParams,
} from './types/events';

/**
 * Gets input for start ID upload journey actor
 * @param ActionEventParams<FraudAlloyContext,FraudAlloyMachineEvents>
 * @returns SendStartIDUploadJourneyParams
 */
export const getStartIDUploadJourneyInput = ({
  event,
}: ActionEventParams<
  FraudAlloyContext,
  FraudAlloyMachineEvents
>): SendStartIDUploadJourneyParams => {
  assertEvent(event, 'SEND_START_ID_UPLOAD_JOURNEY');

  return event.params;
};
